
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/prenota-viaggi",
      function () {
        return require("private-next-pages/[region]/[resort]/prenota-viaggi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/prenota-viaggi"])
      });
    }
  